export default "__VITE_ASSET__CMiSJlHy__"